/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Whitespace_Option_LabelInputs */

const en_style_guide_manager_whitespace_option_label = /** @type {(inputs: Style_Guide_Manager_Whitespace_Option_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whitespace`)
};

const fr_style_guide_manager_whitespace_option_label = /** @type {(inputs: Style_Guide_Manager_Whitespace_Option_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaces`)
};

const de_style_guide_manager_whitespace_option_label = /** @type {(inputs: Style_Guide_Manager_Whitespace_Option_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leerraum`)
};

const it_style_guide_manager_whitespace_option_label = /** @type {(inputs: Style_Guide_Manager_Whitespace_Option_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spazio bianco`)
};

const ru_style_guide_manager_whitespace_option_label = /** @type {(inputs: Style_Guide_Manager_Whitespace_Option_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пространство`)
};

const es_style_guide_manager_whitespace_option_label = /** @type {(inputs: Style_Guide_Manager_Whitespace_Option_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espacio en blanco`)
};

const zh_cn2_style_guide_manager_whitespace_option_label = /** @type {(inputs: Style_Guide_Manager_Whitespace_Option_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空格`)
};

const ja_style_guide_manager_whitespace_option_label = /** @type {(inputs: Style_Guide_Manager_Whitespace_Option_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白`)
};

const hi_style_guide_manager_whitespace_option_label = /** @type {(inputs: Style_Guide_Manager_Whitespace_Option_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`श्वेत रिक्ति`)
};

const pt_pt2_style_guide_manager_whitespace_option_label = /** @type {(inputs: Style_Guide_Manager_Whitespace_Option_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaço em branco`)
};

/**
* | output |
* | --- |
* | "Whitespace" |
*
* @param {Style_Guide_Manager_Whitespace_Option_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_whitespace_option_label = /** @type {((inputs?: Style_Guide_Manager_Whitespace_Option_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Whitespace_Option_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_whitespace_option_label(inputs)
	if (locale === "de") return de_style_guide_manager_whitespace_option_label(inputs)
	if (locale === "it") return it_style_guide_manager_whitespace_option_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_whitespace_option_label(inputs)
	if (locale === "es") return es_style_guide_manager_whitespace_option_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_whitespace_option_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_whitespace_option_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_whitespace_option_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_whitespace_option_label(inputs)
	return en_style_guide_manager_whitespace_option_label(inputs)
});